/*
 * @Author: your name
 * @Date: 2021-07-19 10:39:25
 * @LastEditTime: 2021-07-20 15:12:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\data\defaultData.js
 */
export let defaultData={
    bannerList:[{
        imgUrl:require('../img/banner.png')
    }],
    channelList:[{
        imgUrl:require('../img/pindao.png')
    },{
        imgUrl:require('../img/pindao.png')
    },{
        imgUrl:require('../img/pindao.png')
    },{
        imgUrl:require('../img/pindao.png')
    },{
        imgUrl:require('../img/pindao.png')
    },{
        imgUrl:require('../img/pindao.png')
    }],
    productList:[{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    },{
        skuId:'',
        supplierCompanyId:'',
        name:'商品名称',
        price:'价格',
        imgUrl:require('../img/product212X212.jpeg')
    }],
}
